import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "pagesBanner-block-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "first magic" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "second magic" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "third magic" }, null, -1)
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "pagesBanner-block" }
const _hoisted_7 = { class: "pre-title" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 2,
  class: "list"
}
const _hoisted_12 = { class: "list-el-title" }
const _hoisted_13 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.pageData['topBannerPreTitle']), 1),
        _createElementVNode("h1", {
          class: "title",
          innerHTML: _ctx.pageData['topBannerTitle']
        }, null, 8, _hoisted_8),
        (!!_ctx.pageData['topBannerSubTitle'])
          ? (_openBlock(), _createElementBlock("h2", {
              key: 0,
              class: "sub-title",
              innerHTML: _ctx.pageData['topBannerSubTitle']
            }, null, 8, _hoisted_9))
          : _createCommentVNode("", true),
        (!!_ctx.pageData['topBannerText'])
          ? (_openBlock(), _createElementBlock("h3", {
              key: 1,
              class: "sub-text",
              innerHTML: _ctx.pageData['topBannerText']
            }, null, 8, _hoisted_10))
          : _createCommentVNode("", true),
        (!!_ctx.pageData['topBannerPoints'])
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageData['topBannerPoints'], (listEl) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "list-el",
                  key: listEl.listElTitle
                }, [
                  _createElementVNode("h3", _hoisted_12, _toDisplayString(listEl['topBannerPointsTitle']), 1),
                  _createElementVNode("p", {
                    class: "list-el-text",
                    innerHTML: listEl['topBannerPointsText']
                  }, null, 8, _hoisted_13)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}